import { render } from "./Users.vue?vue&type=template&id=5dcef733&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=5dcef733&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcef733"]])

export default __exports__